import { render } from "./ChatRoom.vue?vue&type=template&id=a73a14c0"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kate/Documents/Home/live-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__